import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/download/more_vert.png'


const _hoisted_1 = { style: {"line-height":"20px"} }
const _hoisted_2 = { style: {"height":"30px","width":"30px","display":"flex","justify-content":"flex-start","align-items":"center","padding":"5px 0px 5px 0px"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","padding":"5px 0px 5px 15px"} }
const _hoisted_5 = { style: {"font-weight":"400","font-size":"14px","color":"#5f6368"} }
const _hoisted_6 = { style: {"display":"flex","justify-content":"flex-start","flex-direction":"column"} }
const _hoisted_7 = { style: {"display":"flex","justify-content":"flex-start","flex-direction":"row","margin-top":"4px"} }
const _hoisted_8 = { class: "commentText" }
const _hoisted_9 = { style: {"color":"#5f6368","margin":"0","line-height":"20px","margin-top":"15px"} }
const _hoisted_10 = {
  class: "commentText",
  style: {"margin-top":"15px"}
}
const _hoisted_11 = { class: "commentText" }

import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'UserComment',
  props: {
    img: {
        type: String,
        default: () => ''
    },
    name: {
        type: String,
        default: '',
    },
    comment: {
        type: String,
        default: '',
    },
    commentDate: {
        type: String,
        default: '',
    },
    reviewCount: {
        type: Number,
        default: () => 0,
    },
},
  setup(__props) {

const props = __props
const comment1 = ref(`<p style="margin: 0;">O jogo é bom , mais precisa de um incentivo, no
geral eu gostei bastante Dá pra pessoa distrair e
jogar é muito saudável ! Amei os porquinhos kkk</p>`)


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_tag = _resolveComponent("van-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, { style: {"padding-top":"25px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: 2 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                style: {"height":"100%","width":"100%","object-fit":"cover","border-radius":"25px"},
                src: props.img
              }, null, 8, _hoisted_3)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: 16 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(__props.name), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: 6 }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { style: {"display":"flex","justify-content":"flex-end","align-items":"center","padding":"5px 0px 5px 0px"} }, [
              _createElementVNode("img", {
                style: {"height":"20px","width":"20px","object-fit":"cover"},
                src: _imports_0
              })
            ], -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { style: {"margin-top":"5px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "6" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createVNode(_component_van_icon, {
                    style: {"padding":"2px","font-weight":"600"},
                    key: i,
                    name: "star",
                    size: "10",
                    color: "#01875f"
                  })
                }), 64))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "10" }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(__props.commentDate), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { style: {} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "24" }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_9, _toDisplayString(__props.comment), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { style: {} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "24" }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('download.helpFullBy') + ' ' + __props.reviewCount + ' '
                    +
                    _ctx.$t('donwload.people')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { style: {"margin-top":"5px","align-items":"center"} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "10" }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('download.helpFull')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_tag, {
              plain: true,
              class: "tagList",
              style: {"border":"1px solid #dadce0"},
              color: "#5f6368",
              round: "",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('download.yes')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "2" }),
        _createVNode(_component_van_col, { span: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_tag, {
              plain: true,
              class: "tagList",
              color: "#5f6368",
              style: {"border":"1px solid #dadce0"},
              round: "",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('download.no')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})